/**
 * What a surface does when a plan card asks to open or build a plan. The Case
 * IDE answers through its own context (editor tab + chat); the agent
 * workspaces provide this so the same `PlanCard` works there: open shows the
 * plan in the artifact panel, build hands it to the workspace chat.
 */
import { createContext, useContext } from "react";

export type PlanActions = {
  openPlan: (planId: string, title: string) => void;
  buildPlan: (planId: string) => void;
};

const PlanActionsContext = createContext<PlanActions | null>(null);

export const PlanActionsProvider = PlanActionsContext.Provider;

export const usePlanActions = (): PlanActions | null =>
  useContext(PlanActionsContext);
